import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import styled from '@emotion/styled';
import CourseCard from '../CourseCard'; // 같은 course-ui 도메인 내 import
import { InfiniteScrollList, StatusDisplay } from '@edusense/shared-ui-kit';
import { useAuth } from '@edusense/shared-auth-core';
import { resolveThumbnailUrl } from '../CourseCard/utils';
// 순서 번호를 표시할 스타일 컴포넌트
const CourseListItemContainer = styled.div`
  display: flex;
  align-items: flex-start; /* CourseCard 상단에 맞춤 */
  gap: 1rem; /* 번호와 카드 사이 간격 */

  /* 화면 너비가 768px 이하일 때 간격 조정 */
  @media (max-width: 768px) {
    gap: 0.5rem; /* 좁은 화면에서 간격 줄이기 */
  }
`;
const OrderNumber = styled.span`
  font-size: 1.2rem;
  font-weight: bold;
  color: var(--theme-text-secondary);
  padding-top: 0.5rem; /* CourseCard 제목과 비슷한 높이에 오도록 조정 */
  min-width: 2ch; /* 두 자리 숫자까지 고려한 최소 너비 */
  text-align: right;

  /* 화면 너비가 768px 이하일 때 숨김 */
  @media (max-width: 768px) {
    display: none;
  }
`;
/**
 * 강의 목록을 표시하는 컴포넌트
 * 무한 스크롤과 순서 표시 기능 지원
 */ const CourseList = ({ courses, showOrder = false, isLoading, isFetchingNextPage, error, hasNextPage, fetchNextPage, observerRef, emptyStateContent = '표시할 강의가 없습니다.', itemDataTestId, onCardClick, onEdit, onDelete, onUnpublish, onReport, isDraft = false })=>{
    const { user } = useAuth();
    // CourseCard에 맞는 형식으로 데이터 변환
    const transformCourse = (course)=>{
        return {
            ...course,
            thumbnailUrl: resolveThumbnailUrl(course.thumbnailUrl, course.mediaFiles),
            rating: course.rating ?? course.averageRating ?? 0,
            isFree: course.isFree ?? (!course.price || course.price.amount === 0),
            isCompleted: course.isCompleted ?? course.progressRate === 1
        };
    };
    // 현재 사용자가 강의의 강사인지 확인
    const isInstructor = (course)=>{
        if (!user || !course.instructor?.id) {
            return false;
        }
        const currentUserId = String(user.id);
        const instructorId = String(course.instructor.id);
        return currentUserId === instructorId;
    };
    // 각 강의를 렌더링하는 함수
    const renderCourseItem = (course)=>/*#__PURE__*/ _jsxs(CourseListItemContainer, {
            "data-testid": itemDataTestId,
            children: [
                showOrder && course.order && /*#__PURE__*/ _jsxs(OrderNumber, {
                    children: [
                        course.order,
                        "."
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        flexGrow: 1
                    },
                    children: /*#__PURE__*/ _jsx(CourseCard, {
                        course: transformCourse(course),
                        isInstructor: isInstructor(course),
                        onCardClick: onCardClick,
                        onEdit: onEdit,
                        onDelete: onDelete,
                        onUnpublish: onUnpublish,
                        onReport: onReport,
                        isDraft: isDraft
                    })
                })
            ]
        }, course.id);
    // 무한 스크롤을 사용하는 경우
    if (observerRef) {
        return /*#__PURE__*/ _jsx(InfiniteScrollList, {
            items: courses,
            renderItem: renderCourseItem,
            isLoading: isLoading,
            isFetchingNextPage: isFetchingNextPage,
            error: error,
            hasNextPage: hasNextPage,
            fetchNextPage: fetchNextPage,
            observerRef: observerRef,
            emptyStateContent: emptyStateContent
        });
    }
    // 기본 리스트 (무한 스크롤 없는 경우)
    if (!courses || courses.length === 0) {
        return /*#__PURE__*/ _jsx(StatusDisplay, {
            type: "empty",
            message: emptyStateContent
        });
    }
    return /*#__PURE__*/ _jsx("div", {
        children: courses.map((course)=>renderCourseItem(course))
    });
};
export default CourseList;
